import { render, staticRenderFns } from "./ErrorExpired.vue?vue&type=template&id=6f49a27d&"
import script from "./ErrorExpired.vue?vue&type=script&lang=ts&"
export * from "./ErrorExpired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports